import type { LayoutChangeEvent } from 'react-native';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { EducationItem } from './education-item';
import { colors } from '../theme';
import { inter500, isWeb } from '../utils/platform';

type EducationSectionProps = {
  onLayout: (event: LayoutChangeEvent) => void;
  onPressTitle: () => void;
};

export function EducationSection({ onLayout, onPressTitle }: EducationSectionProps) {
  return (
    <View nativeID="education" onLayout={onLayout} style={styles.educationSection}>
      <Pressable onPress={onPressTitle} style={styles.sectionTitleLink}>
        <Text style={styles.sectionTitle}>Education</Text>
      </Pressable>

      <View style={styles.educationList}>
        <EducationItem
          location="Edinburgh, UK"
          period="2015 – 2019"
          degree="Bachelor of Software Engineering with Honours"
          institution="Edinburgh Napier University"
          description="Focused on advanced software engineering principles, mobile application development, and software architecture."
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  educationSection: {
    gap: 32,
    paddingVertical: 30,
  },
  sectionTitleLink: {
    alignSelf: 'flex-start',
    ...(isWeb
      ? {
          cursor: 'pointer',
        }
      : null),
  },
  sectionTitle: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 20,
    fontWeight: '500',
    lineHeight: 24,
  },
  educationList: {
    gap: 48,
    width: '100%',
  },
});
